
import { saveAs } from 'file-saver';
import { utils, write } from 'xlsx';

export class ExcelExportService {

  // Export to Excel
  public exportToExcel(data: any[], fileName: string): void {
    try {
      if (!data || data.length === 0) return;

      let finalData = data;

      // Flatten if needed
      if ('positions' in data[0]) {
        const domains = Object.keys(data[0].positions || {});

        // Flatten the data for Excel export
        finalData = data.map(item => {
          const row: any = {
            keyword: item.keyword,
            volume: item.volume,
            kd: item.kd || item.difficulty,
            cpc: typeof item.cpc === 'number'
              ? item.cpc
              : parseFloat(String(item.cpc || 0)),
            intent: item.intent
          };
          
          // Add domain positions
          domains.forEach(domain => {
            row[`${domain} Position`] =
              item.positions[domain] ?? 'Not Ranking';
          });
          
          return row;
        });
      }

      // STEP 1: Get all keys once
      const allKeys = Array.from(
        new Set(finalData.flatMap(row => Object.keys(row)))
      );

      // STEP 2: Filter valid columns
      const validKeys = allKeys.filter(key =>
        finalData.some(row => {
          const value = row[key];
          return value !== null && value !== undefined && value !== "" && value !== "—";
        })
      );

      // STEP 3: Format + clean in ONE pass
      const cleanedData = finalData.map(row => {
        const newRow: Record<string, any> = {};

        validKeys.forEach(key => {
          let value = row[key];

          if (value === null || value === undefined) {
            newRow[key] = "";
          } 
          else if (typeof value === "number") {
            newRow[key] = value.toLocaleString("en-US");
          } 
          else if (typeof value === "string" && !isNaN(Number(value))) {
            newRow[key] = Number(value).toLocaleString("en-US");
          } 
          else {
            newRow[key] = value;
          }
        });

        return newRow;
      });

      const worksheet = utils.json_to_sheet(cleanedData);
      const workbook = utils.book_new();

      utils.book_append_sheet(workbook, worksheet, 'Data');
      
      // Generate Excel file
      const excelBuffer = write(workbook, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

      saveAs(blob, `${fileName}.xlsx`);

      console.log('Excel export completed');
    } catch (error) {
      console.error('Error exporting to Excel:', error);
      throw error;
    }
  }
}
